import { SummaryRow, SummaryContainer } from './style';
import React from 'react';

const CartSummary = ({ subtotal, shipping, total, tax }) => (
  <SummaryContainer>
    <SummaryRow>
      <span>Zwischensumme</span>
      <span>{subtotal}</span>
    </SummaryRow>
    <SummaryRow>
      <span>Versand mit {shipping.shipping_method}</span>
      <span>{shipping.shipping_rate}</span>
    </SummaryRow>
    <SummaryRow className="sum">
      <span>Summe</span>
      <span>{total}</span>
    </SummaryRow>
    <span>inkl. MwSt: ({tax})</span>
  </SummaryContainer>
);

export default CartSummary;



// WEBPACK FOOTER //
// ../shop_main/components/cart/cartSummary.js